import React from "react";
const ProductTitle = ({ attributes, product }) => {
    const level = attributes.level || 2;
    const Tag = ("h" + level);
    return React.createElement(Tag, { className: attributes.className }, product.name);
};
export default ProductTitle;
